import React from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_RESIDUAL_VALUE_GRIDS_READ, ADMIN_RESIDUAL_VALUE_GRIDS_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';
import BrowserComponent from './BrowserComponent';
import HeaderPortal from 'components/layout/HeaderPortal';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import IconButton from 'components/common/buttons/IconButton';
import StateHistoryComponent from './StateHistoryComponent';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_RESIDUAL_VALUE_GRIDS_WRITE} withForbiddenPage={false}>
          <IconButton onClick={() => historyContext.push(`/residualValueGrids/new`)} type='add' size='medium' iconFontSize='medium' />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_RESIDUAL_VALUE_GRIDS_READ}>
        <BrowserComponent />
        <StateHistoryComponent />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
